import styled from '@emotion/styled'

type OperationType = 'add' | 'remove'

export type AddRemoveButtonProps = {
  children: any
  isDisabled?: boolean
  onClick: (e: any) => void
  operationType: OperationType
  width?: string
}

function getBackground(type: OperationType) {
  switch (type) {
    case 'add':
      return 'linear-gradient(var(--Success), var(--Success))'
    case 'remove':
      return 'linear-gradient(var(--Error), var(--Error))'
  }
}

function getForeground(type: OperationType) {
  switch (type) {
    case 'add':
    case 'remove':
      return 'var(--White)'
  }
}

function getHoverForeground(type: OperationType) {
  switch (type) {
    case 'add':
      return 'var(--Info)'
    default:
      return 'var(--White)'
  }
}

function getHoverBackground(type: OperationType) {
  switch (type) {
    case 'add':
      return 'none'
    default:
      return 'var(--Graphite)'
  }
}

type CoreButtonProps = {
  isDisabled?: boolean
  operationType: OperationType
  width?: string
}

const Button = styled.button<CoreButtonProps>`
  ${props => (props.width ? `width: ${props.width}` : '')};
  border: none;
  color: ${props => getForeground(props.operationType)};
  cursor: pointer;
  background: ${props => getBackground(props.operationType)};

  &:hover {
    background: ${props => getHoverBackground(props.operationType)};
    color: ${props => getHoverForeground(props.operationType)};
  }
`

const DisabledButton = styled(Button)`
  cursor: default;
  opacity: 1;
  background: var(--White80);

  &:hover {
    background: ${props => getBackground(props.operationType)};
  }
`

export const AddRemoveButton = ({ isDisabled, operationType, ...props }: AddRemoveButtonProps) => {
  if (isDisabled) {
    return <DisabledButton disabled operationType={operationType} {...props} />
  }
  return <Button {...props} isDisabled={isDisabled} operationType={operationType} />
}
